import MetricsRepository, {
  SaleMetrics,
} from "../repository/metricsRepository";
import { AxiosHttp } from "../../http/axios";

export default class MetricsProvider {
  private static instance: MetricsProvider;
  private metricsRepository: MetricsRepository;

  private constructor() {
    const http = AxiosHttp.getInstance();
    this.metricsRepository = MetricsRepository.getInstance(http);
  }

  static getInstance(): MetricsProvider {
    if (!MetricsProvider.instance) {
      MetricsProvider.instance = new MetricsProvider();
    }
    return MetricsProvider.instance;
  }

  async getSaleMetrics(params: {
    enterpriseId?: number;
    fromDate?: number;
    toDate?: number;
    periodType?: "year" | "month" | "week";
  }): Promise<SaleMetrics> {
    return await this.metricsRepository.getSaleMetrics(params);
  }
}
